export default "__VITE_ASSET__8His9x5k__"